import { BiPieChartAlt2 } from 'react-icons/bi';

import { BaseWidget } from '@/components/Widget/BaseWidget';
import SpendBarChart from '@pages/Manage/components/SpendBarChart.tsx';
import { useManageFinance } from '@pages/Manage/useManageFinance';

import styles from './SpendBarChartWidget.module.scss';

export const SpendBarChartWidget = () => {
  const { items, loading } = useManageFinance({ budgetsEnabled: false });

  return (
    <BaseWidget headerTitle="Spend by Category" headerIcon={<BiPieChartAlt2 />}>
      <div className={styles.chart}>
        <SpendBarChart items={items} loading={loading} />
      </div>
    </BaseWidget>
  );
};

export default SpendBarChartWidget;
